var indentation_default = {
  "indentZero": "SSC-0",
  "indentOne": "AuD2k",
  "indentTwo": "oN2WH",
  "indentThree": "h-rM7",
  "indentFour": "BWncB",
  "indentFive": "YTIbW",
  "indentSix": "_31tuc"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
